var map = {
	"./LolHome.vue": [
		76186,
		836,
		683,
		30,
		5412,
		9491,
		6186
	],
	"./LoldocupHome.vue": [
		6925,
		836,
		683,
		30,
		8414,
		6925
	],
	"./ValorantHome.vue": [
		19724,
		836,
		683,
		30,
		5412,
		5411,
		9724
	],
	"./WrHome.vue": [
		17849,
		836,
		683,
		30,
		5412,
		7849
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 46064;
module.exports = webpackAsyncContext;